export default {
  margin: '0 0 8px 0',
  padding: '10px 20px',
  maxWidth: '720px',
  minWidth: '420px',
  iconMargin: '0 10px 0 0',
  closeMargin: '0 0 0 10px',
  closeSize: '20px',
  closeIconSize: '16px',
  iconSize: '20px',
  fontSize: '14px'
};